module.exports = __webpack_public_path__ + "24712f6c.ttf";